export const CHECK_ICON_CHECKED = 'check-icon fa-light fa-square-check';
export const CHECK_ICON_XMARK = 'check-icon fa-light fa-square-xmark';
export const CHECK_ICON_ACTIVE = 'check-icon fa-light fa-square-check isg-isActive';
